/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friends_OfflineInputs */

const en_friends_offline = /** @type {(inputs: Friends_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Friends and suggestions need a connection.`)
};

const de_friends_offline = /** @type {(inputs: Friends_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freunde und Vorschläge brauchen eine Verbindung.`)
};

/**
* | output |
* | --- |
* | "Friends and suggestions need a connection." |
*
* @param {Friends_OfflineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const friends_offline = /** @type {((inputs?: Friends_OfflineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friends_OfflineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_friends_offline(inputs)
	return en_friends_offline(inputs)
});